import React, { Component } from 'react'
import { Col, Row } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import TitledLabel from '../../controls/TitledLabel'
import { localize } from '../../util/Localizer'
import RBButton from '../../controls/RBButton'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import { withStyles } from '@material-ui/core/styles'

import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import LinkStyles from '../../styles/components/link'
import Divider from '@material-ui/core/Divider'

class ConfirmationRow extends Component {
  constructor () {
    super()
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.state = {
      open: false
    }
  }
  handleOpen () {
    this.setState({ open: true })
  }

  handleClose () {
    this.setState({ open: false })
  }

  renderReasonCode (eobLines) {
    if (eobLines && eobLines.length > 0) {
      return (
        <Col {...Columns.max6}>{/* reason code */}
          <p className='titledLabelTitle reasonCode' style={{ marginBottom: '5px' }}>{localize('pages.SubmitAClaim.ClaimConfirmation.ReasonCode')}:</p>
          <a className={this.props.classes.link} onClick={this.handleOpen}>{localize('pages.SubmitAClaim.ClaimConfirmation.ReasonCode')}</a>
        </Col>
      )
    } else {
      return null
    }
  }

  rednerHcsaConfirmationRow (claim, expense, eobLines) {
    // add up all the claimLines to get total COB amount
    const hasClaims = (expense.claimLines && expense.claimLines.length > 0)
    const coordinationOfBenefitAmount = hasClaims ? expense.claimLines.reduce((accumulator, currentValue) => { return accumulator + currentValue.coordinationOfBenefitAmount }, 0) : 0
    return (
      <Row>
        <Col {...Columns.max12}>
          <TitledLabel title='pages.hcsa.claimHist.claimNumber' value={expense.claimCode} />{/* HCSA Claim Number */}
        </Col>

        <Col {...Columns.max12}>
          <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.SubmittedAmount' value={expense.submittedAmount} format='currency' />{/* submitted amount */}
        </Col>
        <Col {...Columns.max12}>
          <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.PaidAmount' value={expense.claimLines[0].totalPaid} format='currency' />{/* total amount */}
        </Col>

        <Col {...Columns.max12}>
          <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.cobAmount' value={coordinationOfBenefitAmount} format='currency' />{/* CoordinationOfBenefitsAmount */}
        </Col>

        <Col {...Columns.max12}>
          <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.PaidHealthCareSpendingAccountAmount' value={expense.paidByHCSA} format='currency' />{/* paid hcsa amount */}
        </Col>

        <Col {...Columns.max12}>
          <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.Status' className={`${expense.claimStatus}`} value={expense.claimStatus} />{/* status */}
        </Col>
        {this.renderReasonCode(eobLines)}
      </Row>
    )
  }

  renderOtherConfirmationRows (claim, expense, eobLines) {
    const { classes = {} } = this.props
    // render everything but HCSA
    const hasDentalClaims = (claim && claim.DentalClaimLines && claim.DentalClaimLines.length > 0)
    const hasDrugClaims = (claim && claim.DrugClaimLines && claim.DrugClaimLines.length > 0)
    const hasEHCClaims = (claim && claim.ExtendedHealthCareLines && claim.ExtendedHealthCareLines.length > 0)

    // renders the other confirmation rows TODO : should refactor this to seperate like HCSA
    return (
      <Row className={classes.summaryRow}>

        {hasDentalClaims &&
          <Col {...Columns.max6}>
            <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.ProcedureCode' value={expense.serviceCode} />{/* Procedure Code */}
          </Col>
        }

        {hasDrugClaims && !hasDentalClaims &&
          <Col {...Columns.max6}>
            <TitledLabel title='pages.SubmitAClaim.Expenses.Drug.DIN-NPN-HPN' value={expense.serviceCode} />{/* DIN/NPN/HPN */}
          </Col>
        }

        {hasEHCClaims &&
          <Col {...Columns.max6} className={classes.ProcedureDesc}>
            <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.ProcedureDescriptionLabel' value={expense.serviceCodeDescription} />{/* Procedure description */}
          </Col>
        }

        {hasDrugClaims &&
          <Col {...Columns.max6}>
            <TitledLabel title='pages.SubmitAClaim.Expenses.Drug.Drug' value={expense.serviceCodeDescription} />{/* Procedure description */}
          </Col>
        }

        <Col {...Columns.max6}>
          <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.SubmittedAmount' value={expense.submitAmount} format='currency' />{/* submitted amount */}
        </Col>

        <Col {...Columns.max6}>
          <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.PaidAmount' value={expense.totalPaid || expense.paidAmount} format='currency' />{/* pPaid Amount including HCSA (Where applicable) */}
        </Col>

        <Col {...Columns.max6}>
          <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.planPaid' value={expense.planPaid} format='currency' />{/* Plan Paid Amount */}
        </Col>

        <Col {...Columns.max6}>
          <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.cobAmount' value={expense.coordinationOfBenefitAmount} format='currency' />{/* CoordinationOfBenefitsAmount */}
        </Col>

        {this.props.memberSummary.isHCSAAvailable
          ? <Col {...Columns.max6}>
            <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.paidHCSAAmount' value={expense.paidHCSAAmount} format='currency' />{/* HCSA Paid Amount */}
          </Col> : null}

        <Col {...Columns.max6}>
          <TitledLabel title='pages.SubmitAClaim.ClaimConfirmation.Status' className={`${expense.status}`} value={expense.status || expense.claimStatus} />{/* status */}
        </Col>

        {this.renderReasonCode(eobLines)}

      </Row>

    )
  }

  render () {
    const { claim, expense, classes = {} } = this.props
    const hasHCSAClaims = (claim.HCSAExpenseLines && claim.HCSAExpenseLines.length > 0)
    const eobLines = hasHCSAClaims ? (expense.claimLines && expense.claimLines[0].explanationOfBenefits) : expense.explanationOfBenefits
    const lineRendererResults = hasHCSAClaims ? this.rednerHcsaConfirmationRow(claim, expense, eobLines) : this.renderOtherConfirmationRows(claim, expense, eobLines)

    const actions = [
      <RBButton
        key='close'
        label={localize('common.close')}
        color
        onClick={this.handleClose}
      />]
    return (
      <Paper className={classes.summaryCard}>
        {lineRendererResults}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          PaperProps={{ style: { width: 500 } }}
        >
          <DialogContent>
            <div>
              <Row>
                <Col xs={3}>
                  <p className='reasonCodeHeader'>{localize('pages.SubmitAClaim.ClaimConfirmation.ReasonCode')}</p>
                </Col>
                <Col xs={9}>
                  <p className='reasonCodeHeader'>{localize('pages.SubmitAClaim.ClaimConfirmation.Description')}</p>
                </Col>
              </Row>
              {eobLines && eobLines.length > 0
                ? eobLines.map((rc, i) => {
                  return (
                    <div key={i}>
                      <Row>
                        <Col xs={3}>
                          <p>{rc.code}</p>
                        </Col>
                        <Col xs={9}>
                          <p>{rc.message}</p>
                        </Col>
                      </Row>
                      <Divider />
                    </div>
                  )
                }
                ) : null}
            </div>
            <DialogActions>{actions}</DialogActions>
          </DialogContent>
        </Dialog>
      </Paper>
    )
  }
}

const styles = {
  ...CardStyles,
  ...LinkStyles,
  summaryRow: {
    // TODO: The `justifyContent` rules below are overriding a very
    // broad selector in print.css. We can remove them when print.css
    // in no longer in use.
    ['@media print']: { // eslint-disable-line no-useless-computed-key
      marginBottom: 10,
      marginTop: 10,
      '& > div': {
        justifyContent: 'flex-start !important'
      },
      '& .titledLabelTitle': {
        marginLeft: '0 !important',
        marginBottom: '0 !important',
        fontSize: '1rem'
      }
    }
  },
  ProcedureDesc: {
    wordBreak: 'break-word',
    wordWrap: 'break-word'
  }
}

export default withStyles(styles)(ConfirmationRow)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/confirmationRow.js